import { Button, Dropdown, Table, type TableProps } from "antd";
import BaseCard from "../../components/card/BaseCard";
import StatisticsCard from "../../components/card/StatisticsCard";
import ColumnChart from "../../components/chart/ColumnChart";
import RadialBarCart from "../../components/chart/RadialBarCart";
import SliderBanner from "../../components/SliderBanner";
import { Icon } from "@iconify/react";
import { numberFormatterLabel } from "../../helper/method";
import ButtonIcon from "../../components/ButtonIcon";
import StatusBox from "../../components/StatusBox";
import { Link } from "react-router";
import { useStore } from "zustand";
import { useDashboardName } from "../../store/headerName";
import { useEffect, useState } from "react";
import BaseTable from "../../components/BaseTable";
import { $api, type components } from "../../helper";
import { useToken } from "../../store/token";
import { tokenMock } from "../../helper/mock";

export default function Home() {
  const { setDashboardName } = useStore(useDashboardName);
  const { token } = useStore(useToken);
  const { data, isPending, mutate } = $api.useMutation(
    "get",
    "/site-api/v1/dashboard-detail/",
  );
  const [selectYears, setSelectYears] = useState(0);
  useEffect(() => {
    setDashboardName("داشبورد");
    mutate(
      {
        headers: {
          Authorization: tokenMock,
          lang: "fa",
        },
        params: {
          query: {
            year_filter: selectYears,
          },
        },
      },
      {
        onSuccess: (data) => {
          setSelectYears(data?.data.purchase_chart.years[0].year);
        },
      },
    );
  }, []);

  const columns: TableProps<
    components["schemas"]["SiteDashboardTransactionItem"]
  >["columns"] = [
    {
      title: "#",
      dataIndex: "key",
      key: "key",
      render: (_, record, index) => <span>{index + 1}</span>,
    },
    {
      title: "شناسه فاکتور",
      dataIndex: "code",
      key: "code",
    },
    {
      title: "قیمت",
      dataIndex: "address",
      key: "address",
      render: (_, record) => numberFormatterLabel(record.price),
    },
    {
      title: "وضعیت",
      key: "tags",
      dataIndex: "tags",
      render: (_, record) => <StatusBox status={record.delivery_status} />,
    },
    {
      title: "عملیات",
      key: "action",
      render: () => (
        <ButtonIcon icon="solar:menu-dots-bold" className="rotate-90" />
      ),
    },
  ];

  return (
    <div className="flex flex-col gap-6 w-full">
      {/* slider */}
      <SliderBanner />
      {/* Statistics Card */}
      <div className="grid lg:grid-cols-3 grid-cols-1 gap-6">
        <div className="col-span-1">
          <StatisticsCard
            icon="solar:users-group-two-rounded-bold-duotone"
            number={data?.data.count_cpu.user_count ?? 0}
            title="تعداد کاربران"
          />
        </div>
        <div className="col-span-1">
          <StatisticsCard
            icon="solar:box-bold-duotone"
            number={data?.data.count_cpu.product_count ?? 0}
            title="تعداد محصولات"
          />
        </div>
        <div className="col-span-1">
          <StatisticsCard
            icon="solar:monitor-bold-duotone"
            number={data?.data.count_cpu.course_count ?? 0}
            title="تعداد دوره ها"
          />
        </div>
      </div>
      {/* Chart */}
      <div className="grid grid-cols-12 gap-6">
        {/* Radial Bar Chart */}
        <BaseCard
          props={{
            className:
              "lg:col-span-4 lg:aspect-auto aspect-square col-span-full gap-6 flex flex-col items-center",
          }}
        >
          <div className="w-full flex flex-col gap-2">
            <h2 className="text-20-semi-bold">سیستم عامل ها</h2>
            <p className="text-16-regular text-grayscale-800">
              دانلود شده توسط سیستم عامل
            </p>
          </div>
          <RadialBarCart />
        </BaseCard>
        {/* Bar Chart */}
        <BaseCard
          props={{
            className:
              "lg:col-span-8 col-span-full w-full lg:aspect-auto aspect-square flex justify-between gap-6 flex flex-col items-center",
          }}
        >
          <div className="justify-between items-center w-full flex">
            <div className="w-full flex flex-col gap-2">
              <h2 className="text-20-semi-bold">نمودار خرید براساس ماه</h2>
              <p className="text-16-regular text-grayscale-800">
                (+43٪) نسبت به سال گذشته
              </p>
            </div>
            <Dropdown
              menu={{
                items: data?.data.purchase_chart.years.map((e, i) => ({
                  label: <span className="">{e.year}</span>,
                  key: i,
                })),
              }}
              trigger={["click"]}
            >
              <Button>
                {selectYears}
                <Icon
                  className="text-xl"
                  icon={"solar:alt-arrow-down-linear"}
                />
              </Button>
            </Dropdown>
          </div>
          <ColumnChart data={data?.data.purchase_chart} />
        </BaseCard>
      </div>
      <div className="grid gap-6 grid-cols-12">
        {/* Table Transition */}
        <BaseCard
          props={{
            className: "lg:col-span-8 col-span-full flex flex-col gap-6",
          }}
        >
          <span className="text-20-semi-bold">آخرین تراکنش ها</span>
          <BaseTable props={{ className: "w-full grid! grid-cols-1!" }}>
            <Table<components["schemas"]["SiteDashboardTransactionItem"]>
              pagination={false}
              className="col-span-1!"
              scroll={{ x: "max-content" }}
              columns={columns}
              dataSource={data?.data.transaction.transaction}
              loading={isPending}
            />
          </BaseTable>
          <div className="w-full justify-end flex">
            <Link
              to={"/"}
              className="text-primary-500! flex text-16-regular items-center gap-1"
            >
              مشاهده همه
              <Icon
                icon={"solar:alt-arrow-left-line-duotone"}
                className="text-xl"
              />
            </Link>
          </div>
        </BaseCard>
        {/* Activity History */}
        <BaseCard
          props={{
            className: "lg:col-span-4 col-span-full flex flex-col",
          }}
        >
          <div className="w-full flex items-center justify-between">
            <span className="text-20-semi-bold">تاریخچه فعالیت</span>
            <Button>عملکرد کاربران</Button>
          </div>
        </BaseCard>
      </div>
    </div>
  );
}
